import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import Fleet from "@/pages/Fleet";
import Catalogue from "@/pages/Catalogue";
import Devis from "@/pages/Devis";
import Contact from "@/pages/Contact";
import CartPage from "@/pages/CartPage";
import Success from "@/pages/Success";
import ProductDetail from "@/pages/ProductDetail";
import LegalPage from "@/pages/LegalPage";

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/flotte" element={<Fleet />} />
              <Route path="/catalogue" element={<Catalogue />} />
              <Route path="/produit/:id" element={<ProductDetail />} />
              <Route path="/devis" element={<Devis />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/success" element={<Success />} />
              <Route path="/mentions-legales" element={<LegalPage pageKey="mentions" />} />
              <Route path="/cgv" element={<LegalPage pageKey="cgv" />} />
              <Route path="/confidentialite" element={<LegalPage pageKey="confidentialite" />} />
              <Route path="/cookies" element={<LegalPage pageKey="cookies" />} />
            </Routes>
          </Layout>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
